import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Auto_SubLevelAccount = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [GroupId, setGroupId] = React.useState(-1);

    useImperativeHandle(ref, () => ({

        Bind(Id, Search, groupId) {
            setGroupId(groupId)
            if (groupId != -1) {
                var RequestOptions = {
                    data: {
                        'Title': Search,
                        'GroupId': groupId,
                    },
                    url: General.ApiRoute() + "/Account_SubLevelGroup/Account_GetByGroupId",
                    method: "post",
                    withCredentials: true,

                    headers: {
                        'ApiKey': General.APIKey(),
                        'Content-Type': 'application/json'
                    }
                }
                trackPromise(
                    axios(RequestOptions)
                        .then(result => {
                            var tmp = []
                            for (var i = 0; i < result.data.length; i++) {
                                tmp.push({
                                    Row: i + 1,
                                    value: result.data[i].accountId + "|" + result.data[i].title +" [" + result.data[i].code + "]"+ "|" + result.data[i].code + "|" + result.data[i].financialBalance + "|" + result.data[i].groupId,
                                    lable: result.data[i].title +" [" + result.data[i].code + "]",

                                })
                                // // temp[index].Sub_Acc_Id1 = value.split("|")[0];
                                // // temp[index].Sub_Acc_LTitle1 = value.split("|")[1];
                                // // temp[index].Sub_Acc_LCode1 = value.split("|")[2];
                                // // temp[index].Sub_Acc_LRemain1 = value.split("|")[3];
                                // // temp[index].Sub_Acc_L1 = value.split("|")[4];

                            }
                            setList(tmp)

                        })
                        .catch((error) => {
                            console.dir(error)
                        })
                )

            }
            else
                setList([]);

        },
        SetEnable(groupId) {
            setGroupId(groupId)

        }
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((item) => ({
                label: `${item.lable}`,
                value: `${item.value}`,
            }))}
            value={props.value}
            label={props.lable}
            onChange={(event) => props.onChange(event)}
            onSelect={(event) => props.onSelect(event)}
            // onKeyUp={(event) => props.onKeyUp(event)}
            disabled={GroupId == -1 ? true : false}
        // className='FocusSubAutoComplete'
        />)
});

export default Auto_SubLevelAccount;